import React from "react";

const LegendItem = ({ colorClass, label, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold ring-1 ${className}`}
  >
    <span className={`h-2 w-2 rounded-full ${colorClass}`} />
    {label}
  </span>
);

const BracketLegend = () => {
  return (
    <div className="border-b border-slate-200 bg-slate-50 px-5 py-3 dark:border-white/10 dark:bg-white/[0.03]">
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <LegendItem
          label="Vainqueur"
          colorClass="bg-emerald-500"
          className="bg-emerald-100 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-100 dark:ring-emerald-400/30"
        />

        <LegendItem
          label="Perdant / terminé"
          colorClass="bg-slate-400"
          className="bg-slate-100 text-slate-600 ring-slate-200 dark:bg-white/10 dark:text-slate-300 dark:ring-white/10"
        />

        <LegendItem
          label="En attente"
          colorClass="bg-amber-500"
          className="bg-amber-100 text-amber-700 ring-amber-200 dark:bg-amber-500/15 dark:text-amber-100 dark:ring-amber-400/30"
        />

        <span className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-bold text-slate-500 ring-1 ring-slate-200 dark:bg-white/5 dark:text-slate-400 dark:ring-white/10">
          <span className="h-2 w-2 rounded-full border border-dashed border-slate-400" />
          Exempt
        </span>
      </div>
    </div>
  );
};

export default BracketLegend;